import { makeStyles } from '@mui/styles';

import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    padding: '40px 25px',
    backgroundColor: theme.palette.whitePepper.main,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },

  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    columnGap: '20px',
    rowGap: '45px',
    [theme.breakpoints.up(720)]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up(1075)]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    [theme.breakpoints.up(1500)]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },

  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    cursor: 'pointer',
  },

  imgSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '20px',
    marginBottom: '10px',
    overflow: 'hidden',
  },

  imgWrapper: {
    flexShrink: 0,
    position: 'relative',
  },

  textWrapper: {
    width: '95%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '10px',
    marginBottom: '10px',
  },
});
